import {Button} from '@/components/atoms'
import {PageHeader} from '@/components/molecules'

const BasicInfo = ({handleButtonClick, isDark}) => {
  return (
    <>
      <div className="flex items-center justify-between">
        <PageHeader title={'Basic Info'} />
        <Button
          handleButton={handleButtonClick}
          uiSchema={{
            size: 'medium',
            title: 'Agent View',
            variant: 'primary',
            isDark,
            iconTrailing: 'arrow_forward',
          }}
        />
      </div>

      <div className="background-1D1D1D mt-4 grid grid-cols-2 text-sm">
        <div className="grid grid-cols-2 gap-y-2">
          <div className="space-y-4 text-neutral-400	">
            <div>
              <span className="font-normal">Store Name</span>
              <hr className="mt-1 border-gray-600" />
            </div>
            <div>
              <span className="font-normal">ERP ID</span>
              <hr className="mt-1 border-gray-600" />
            </div>
            <div>
              <span className="font-normal">Phone Number</span>
              <hr className="mt-1 border-gray-600" />
            </div>
            <div>
              <span className="font-normal">Email</span>
              <hr className="mt-1 border-gray-600" />
            </div>
            <div>
              <span className="font-normal">Current Points</span>
              <hr className="mt-1 border-gray-600" />
            </div>
          </div>

          <div className="space-y-4 text-white">
            <div>
              <span className="font-bold">Bo’s dega main st</span>
              <hr className="mt-1 border-gray-600" />
            </div>
            <div>
              <span className="font-bold">5123423</span>
              <hr className="mt-1 border-gray-600" />
            </div>
            <div>
              <span className="font-bold">0101110010</span>
              <hr className="mt-1 border-gray-600" />
            </div>
            <div>
              <span className="font-bold">Name@gmail.com</span>
              <hr className="mt-1 border-gray-600" />
            </div>
            <div>
              <span className="font-bold">1205</span>
              <hr className="mt-1 border-gray-600" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BasicInfo
